var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 41,
    viewBox: "0 0 48 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1386 35.1114H7.75436C6.47981 35.1114 5.4412 34.0095 5.4412 32.6518V8.67108L22.5586 22.3217C22.9703 22.6512 23.4584 22.8136 23.9465 22.8136C24.4346 22.8136 24.9227 22.6512 25.3344 22.3217L42.4518 8.67108V32.6518C42.4518 34.0095 41.4132 35.1114 40.1386 35.1114ZM38.5957 5.5971L23.9465 17.28L9.29723 5.5971H38.5957ZM40.1392 0.679688H7.75492C3.92895 0.679688 0.81543 3.99026 0.81543 8.05838V32.654C0.81543 36.7222 3.92895 40.0327 7.75492 40.0327H40.1392C43.9652 40.0327 47.0787 36.7222 47.0787 32.654V8.05838C47.0787 3.99026 43.9652 0.679688 40.1392 0.679688Z",
    fill: "#00E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.1fde7f4a9bc90aace3183ca5c427f6c3.svg";
export { ForwardRef as ReactComponent };